import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonService } from './common-service.service';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LoginFooterComponent } from './login-footer/login-footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { RouterModule } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { MyDatePickerModule } from 'mydatepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import {
  MatAutocompleteModule, MatButtonModule, MatCheckboxModule, MatDatepickerModule,
  MatFormFieldModule, MatInputModule, MatRadioModule, MatSelectModule, MatSliderModule,
  MatSlideToggleModule, MatTableModule, MatPaginatorModule, MatDialogModule, MatIconModule
} from '@angular/material';
import { StatusDialogComponent } from './status-dialog/status-dialog.component';
import { PaymentDialogComponent } from './payment-dialog/payment-dialog.component';
import { UploadDialogComponent } from './upload-dialog/upload-dialog.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { NumberCurrencyPipe } from './number-currency.pipe';
import { LoginComponent } from './login/login.component';
import { ChartsModule } from 'ng2-charts';
import { NumberOnlyDirective } from './directives/number-only.directive';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoginFooterComponent,
    SidebarComponent,
    ConfirmationDialogComponent,
    StatusDialogComponent,
    PaymentDialogComponent,
    UploadDialogComponent,
    MainLayoutComponent,
    NumberCurrencyPipe,
    LoginComponent,
    NumberOnlyDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    LoadingBarModule,
    RouterModule,
    BlockUIModule.forRoot(),
    ToastrModule.forRoot(),
    NgSelectModule,
    LoadingBarHttpClientModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    MatTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatDialogModule,
    MatIconModule,
    ReactiveFormsModule,
    ChartsModule
  ],
  providers: [
    CommonService
  ],
  exports: [
    FormsModule,
    BrowserModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    CommonModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    LoginFooterComponent,
    SidebarComponent,
    BlockUIModule,
    ToastrModule,
    NgSelectModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    MatTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatDialogModule,
    MainLayoutComponent,
    NumberCurrencyPipe,
    MatIconModule,
    ReactiveFormsModule,
    LoginComponent,
    ChartsModule,
    NumberOnlyDirective
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    StatusDialogComponent,
    PaymentDialogComponent,
    UploadDialogComponent
  ]
})
export class SharedModule { }
